import React from 'react';
import { toast as rtToast } from 'react-toastify';
import CustomToast from './CustomToast';

const renderCustomToast = (message, type) => ({ closeToast, data }) => (
  <CustomToast
    closeToast={closeToast}
    data={{ message: data?.message ?? message, type: data?.type ?? type }}
  />
);

const defaultOptions = {
  className: 'wms-custom-toast',
  icon: false,
  closeButton: false,
};

/** Previous ToastContainer default — keep info/warning auto-dismiss unchanged. */
const INFO_WARNING_AUTO_CLOSE_MS = 3000;

function normalizeErrorMessage(errOrMsg) {
  if (typeof errOrMsg === 'string') return errOrMsg;
  return (
    errOrMsg?.response?.data?.message ||
    errOrMsg?.response?.data?.error ||
    errOrMsg?.message ||
    'Something went wrong'
  );
}

function dispatchCustomToast(message, type, options = {}, autoClose) {
  return rtToast(renderCustomToast(message, type), {
    ...defaultOptions,
    ...options,
    autoClose,
    data: { ...options.data, message, type },
  });
}

/**
 * Default export only — methods are defined inline so production tree-shaking
 * cannot drop named exports that the default object referenced via shorthand.
 */
const toast = {
  success(message, options = {}) {
    return dispatchCustomToast(message, 'success', options, false);
  },
  error(errOrMsg, options = {}) {
    const message = normalizeErrorMessage(errOrMsg);
    return dispatchCustomToast(message, 'error', options, false);
  },
  warning(message, options = {}) {
    return dispatchCustomToast(message, 'warning', options, INFO_WARNING_AUTO_CLOSE_MS);
  },
  info(message, options = {}) {
    return dispatchCustomToast(message, 'info', options, INFO_WARNING_AUTO_CLOSE_MS);
  },
  dismiss: rtToast.dismiss,
  isActive: rtToast.isActive,
  update: rtToast.update,
  promise: rtToast.promise,
};

export default toast;
